export enum EnumStatusSolicitacaoTecnica {
    EmElaboracao = 1,
	Finalizada = 2,
    NaoRespondida = 3,
    Cancelada = 4,
    SolicitacaoProrrogacao = 5,
    Prorrogada = 6,
    RespondidaParcialmente = 7,
    RespondidaTotalmente = 8,
    NaoAtendidaParcialmente = 9,
    NaoAtendidaTotalmente = 10,
    Pendente = 11,
    ProrrogacaoRejeitada = 12
}